import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Table } from "../../components";
import { useAppContext } from "../../context/state";
import { useRequest } from "../../utils";
//locall
import "./ShowProducts.css";

const ShowProducts = (props) => {
  const [
    get_products_error,
    get_products_loading,
    get_products_data,
    get_products_function,
  ] = useRequest({
    method: "get",
    url: "/get_products",
  });

  return (
    <>
      {/* <!-- BEGIN: Content--> */}
      <div class="content-header row">
        <div class="content-header-left col-12 mb-2 mt-1">
          <div class="row breadcrumbs-top">
            <div class="col-12">
              <h5 class="content-header-title float-left pr-1">
                جدول های اطلاعاتی
              </h5>
              <div class="breadcrumb-wrapper">
                <ol class="breadcrumb p-0 mb-0">
                  <li class="breadcrumb-item">
                    <a href="index.html">
                      <i class="bx bx-home-alt"></i>
                    </a>
                  </li>
                  <li class="breadcrumb-item active">جدول اطلاعات</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="content-body">
        <div class="row">
          <div class="col-12">
            <p>
              مستندات کامل را بخوانید در
              <a href="https://datatables.net/" target="_blank">
                اینجا
              </a>
            </p>
          </div>
        </div>
        {get_products_data ? (
          <Table
            Thead={() => (
              <tr>
                <th className="table--title">عنوان</th>
                <th className="table--title">نوع</th>
                <th className="table--title">قیمت</th>
                <th className="table--title">تحفیف</th>
                <th className="table--title">عملیات</th>
              </tr>
            )}
            Tbody={() =>
              get_products_data.products.map((item) => (
                <tr>
                  <td>{item.title}</td>
                  <td>{item.type}</td>
                  <td>{item.price}</td>
                  <td>{item.discount}</td>
                  <td>
                    {item.type === "courses" ? (
                      <Link to={"/dashboard/terms/" + item._id}>
                        <button
                          type="button"
                          class="btn btn-primary round mr-1 mb-1 btn-sm"
                        >
                          ترم ها
                        </button>
                      </Link>
                    ) : null}
                    {item.type === "products" || "frequency" ? (
                      <Link to={"/dashboard/files/" + item._id}>
                        <button
                          type="button"
                          class="btn btn-info round mr-1 mb-1 btn-sm"
                        >
                          فایل ها
                        </button>
                      </Link>
                    ) : null}
                    <Link
                      to={{
                        pathname: `/dashboard/EditProduct/${item._id}`,
                        query: { item },
                      }}
                    >
                      <button
                        type="button"
                        class="btn btn-warning round mr-1 mb-1 btn-sm"
                      >
                        ویرایش
                      </button>
                    </Link>
                  </td>
                </tr>
              ))
            }
          />
        ) : null}
      </div>
      {/* <!-- END: Content--> */}
    </>
  );
};

export { ShowProducts };
